/**
 * @class {T.PurchaseForm}
 * @extends {mkE.Base}
 */
T.PurchaseForm = Class(
	/**
	 * @lends {T.PurchaseForm#}
	 */
	{
		_selectedTab: 'private',
		_tabHeaders: {},
		_tabs: {},
		_companyFields: {},

		/**
		 * @constructs
		 */
		__construct: function(data){
			this.data = data || {};

			this.node = mkE({
				tag: 'div',
				className: 'rg-purchase-address',
				els: [
					{
						tag: 'div',
						className: 'purchase-tabs',
						els: [
							this._getTabHeaders(),
							{
								tag: 'div',
								className: 'purchase-tabs-content',
								els: [
									this._getPrivateTab(),
									this._getCompanyTab()
								]
							}
						]
					}
				]
			})
		},

		_getTabHeaders: function(){
			return mkE({
				tag: 'div',
				className: 'purchase-tabs-header',
				els: [
					this._tabHeaders['private'] = mkE({
						tag: 'a',
						className: this._selectedTab === 'private' ? 'active' : '',
						text: D.Lang.get('profile.team.purchase.tabs.private'),
						onclick: D.closure(this, function(){
							this._switchTab('private');
						})
					}),
					this._tabHeaders['company'] = mkE({
						tag: 'a',
						className: this._selectedTab === 'company' ? 'active' : '',
						text: D.Lang.get('profile.team.purchase.tabs.company'),
						onclick: D.closure(this, function(){
							this._switchTab('company');
						})
					})
				]
			});
		},

		_getPrivateTab: function(){
			let code = 371;
			let value = '';
			let active = '';
			if( this.data.phone ){
				code = Number(this.data.phone.code || 371);
				value = this.data.phone.phone || '';
			}
			if( this._selectedTab === 'private' ){
				active = ' active';
			}
			return this._tabs['private'] = mkE({
				tag: 'div',
				className: 'purchase-tab purchase-tab-private' + active,
				els: [
					this._cardPhone = new T.Form.Phone({
						caption: D.Lang.get('profile.team.purchase.phone'),
						border: true,
						code: code,
						value: value
					})
				]
			});
		},

		_getCompanyTab: function(){
			let countries = Object.entries(D.Lang.get('countries')).
					map(([key, value]) => ({
						value: key,
						caption: value,
					}));

			let active = '';
			if( this._selectedTab === 'company' ){
				active = ' active';
			}
			let tab = mkE({
				tag: 'div',
				className: 'purchase-tab purchase-tab-company' + active
			});

			let name = '';
			let code = 371;
			let phone = '';
			let registrationNumber = '';
			let vatNumber = '';
			let country = 'LV';
			let city = '';
			let address = '';

			if( this.data.companyData ){
				name = this.data.companyData.name || '';
				if( this.data.phone ){
					code = Number(this.data.phone.code || 371);
					phone = this.data.phone.phone || '';
				}
				registrationNumber = this.data.companyData.registrationNumber || '';
				vatNumber = this.data.companyData.vat || '';
				country = this.data.companyData.country || '';
				city = this.data.companyData.city || '';
				address = this.data.companyData.address || '';
			}

			mkE({
				tag: 'div',
				className: 'form-row form-row-2',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._companyFields['name'] = new T.Form.Input({
								caption: D.Lang.get('profile.team.purchase.company.name'),
								border: true,
								value: name
							})
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							this._companyFields['phone'] = new T.Form.Phone({
								caption: D.Lang.get('profile.team.purchase.company.phone'),
								border: true,
								code: code,
								value: phone
							})
						]
					}
				]
			}).append(tab);

			mkE({
				tag: 'div',
				className: 'form-row form-row-2',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._companyFields['reg'] = new T.Form.Input({
								caption: D.Lang.get('profile.team.purchase.company.reg'),
								border: true,
								value: registrationNumber
							})
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							this._companyFields['vat'] = new T.Form.Input({
								caption: D.Lang.get('profile.team.purchase.company.vat'),
								border: true,
								value: vatNumber
							})
						]
					}
				]
			}).append(tab);

			mkE({
				tag: 'div',
				className: 'form-row form-row-2',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._companyFields['country'] = new T.Form.Select({
								caption: D.Lang.get('profile.team.purchase.company.country'),
								border: true,
								options: countries,
								value: country
							})
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							this._companyFields['city'] = new T.Form.Input({
								caption: D.Lang.get('profile.team.purchase.company.city'),
								border: true,
								value: city
							})
						]
					}
				]
			}).append(tab);

			mkE({
				tag: 'div',
				className: 'form-row',
				els: [
					this._companyFields['address'] = new T.Form.Input({
						caption: D.Lang.get('profile.team.purchase.company.address'),
						border: true,
						value: address
					})
				]
			}).append(tab);

			return this._tabs['company'] = tab;
		},

		_switchTab: function(activeTab) {
			for( let tab in this._tabHeaders ){
				if( !this._tabHeaders.hasOwnProperty(tab) ){
					continue;
				}
				if( tab === activeTab ){
					addClassName(this._tabHeaders[tab], 'active');
					addClassName(this._tabs[tab], 'active');
				}else{
					removeClassName(this._tabHeaders[tab], 'active');
					removeClassName(this._tabs[tab], 'active');
				}
			}
			this._selectedTab = activeTab;
		},

		clearErrors: function(){
			this._cardPhone.error(null);
			for( let field in this._companyFields ){
				if( !this._companyFields.hasOwnProperty(field) ){
					continue;
				}
				this._companyFields[field].error(null);
			}
		},

		setErrors: function(errors){
			if( errors.phone ){
				this._cardPhone.error(D.Lang.get('profile.team.purchase.errors.phone.' + errors.phone));
			}
			if( errors.company ){
				for( let fieldName in errors.company ){
					if( !errors.company.hasOwnProperty(fieldName) ){
						continue;
					}
					let field = this._companyFields[fieldName];
					if( !field ){
						continue;
					}
					field.error(D.Lang.get('profile.team.purchase.errors.' + fieldName + '.' + errors.company[fieldName]));
				}
			}
		},

		getData: function(){
			let type = this._selectedTab;
			let data = {};
			if( type === 'company' ){
				for( let field in this._companyFields ){
					if( !this._companyFields.hasOwnProperty(field) ){
						continue;
					}
					let value = this._companyFields[field].value();
					if( field === 'phone' ){
						if( value ){
							data[field] = '+' + value.code + value.value;
						}else{
							data[field] = '';
						}
					}else{
						data[field] = value;
					}
				}
			}else{
				let value = this._cardPhone.value();
				if( value ){
					data['phone'] = '+' + value.code + value.value;
				}else{
					data['phone'] = '';
				}
			}
			return {
				type: type,
				data: data
			};
		}
	},
	mkE.Base
);
